import BadgeIcon from "../../../Icons/BadgeIcon";

function SingleChoice({ entryjson, inputs, setInputs, saveMemberEntry }) {
  //const { showToast } = useToast();

  const entrydet = JSON.parse(entryjson.entry);
  const entrychoice = entrydet?.choices || "";

  const choices = entrychoice
    .split(",")
    .filter((choices) => choices.trim() !== "");

  const handleChange = (e) => {
    setInputs((inputs) => {
      return {
        ...inputs,
        [e.target.name]: e.target.value,
      };
    });
    // console.log(inputs?.entry_val);
  };

  const saveEntry = () => {
    saveMemberEntry();
  };

  return (
    <div>
      <div className="cursor-default">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="md:w-[440px]">
            <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 pb-1">
              {entryjson.headline}
            </h4>
            <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] mb-1">
              {entrydet?.description}
            </p>
          </div>
          <div className="hidden min-[426px]:block">
            <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
              <BadgeIcon width={20} height={20} className={"mr-1"} />
              {entrydet?.worth} <span className="text-sm ml-1">Points</span>
            </span>
          </div>
        </div>
        <div className="mt-2">
          {choices.length > 0 ? (
            choices.map((choices_det, index) => (
              <div key={index} className="flex items-center mb-2">
                <input
                  type="radio"
                  id={`choices-${index}`}
                  name="entry_val"
                  value={choices_det.trim()}
                  onChange={handleChange}
                  className="w-4 h-4 radio-primary text-green-600 bg-gray-100 border-gray-300 cursor-pointer focus:ring-green-500 focus:ring-2 checked:bg-green-600 checked:border-green-600 mr-2"
                />
                <label
                  htmlFor={`choices-${index}`}
                  className="font-normal text-[12px] md:text-[15px] leading-[22px] text-black opacity-100"
                >
                  {choices_det.trim()}
                </label>
              </div>
            ))
          ) : (
            <div>No data Found </div>
          )}
        </div>
        <div className="flex items-center justify-between">
          <div className="">
            <button
              disabled={!inputs?.entry_val}
              onClick={() => saveEntry()}
              className={`primary_btn_bg primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] text-left border border-[#0274F7] ${
                !inputs?.entry_val
                  ? "opacity-50 cursor-not-allowed"
                  : " hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]"
              }`}
            >
              Earn Points
            </button>
          </div>
          <div className="pt-2">
            <span class="earn_points_btn bg-white ml-2 text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7] sm:hidden">
              <BadgeIcon width={20} height={20} className={"mr-1"} />
              {entrydet?.worth} <span className="text-sm ml-1">Points</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleChoice;
